'use client'

export default function GlobalError({ error }: { error: Error }) {
  // You can add custom error logging here if needed
  console.error('Global error caught:', error)

  return (
    <html>
      <body>
        <div style={{ padding: '2rem' }}>
          <h1>Something went wrong!</h1>
          <p>We're sorry, but an unexpected error occurred.</p>
        </div>
      </body>
    </html>
  )
}
